import React from 'react';
import { DOCUMENT_TEMPLATE_MODE_IDS } from '@constants';

const getDefaultPortfolioMonitoringParams = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // 0-indexed, so +1

  // Quarter end months: Mar (3), Jun (6), Sep (9), Dec (12)
  const quarterEndMonths = [3, 6, 9, 12];
  const quarterNames = ['Q1', 'Q2', 'Q3', 'Q4'];
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Find the most recent completed quarter
  let mostRecentQuarterIndex = -1;
  let mostRecentQuarterYear = currentYear;

  for (let i = quarterEndMonths.length - 1; i >= 0; i--) {
    const qMonth = quarterEndMonths[i];
    if (currentMonth > qMonth) {
      // Quarter has definitively ended
      mostRecentQuarterIndex = i;
      break;
    }
  }

  // If no completed quarter this year, use Q4 of last year
  if (mostRecentQuarterIndex === -1) {
    mostRecentQuarterIndex = 3; // Q4
    mostRecentQuarterYear = currentYear - 1;
  }

  const fiscalQuarter = quarterNames[mostRecentQuarterIndex];
  const quarterEndMonth = quarterEndMonths[mostRecentQuarterIndex];
  const calendarDate = `${monthNames[quarterEndMonth - 1]} ${mostRecentQuarterYear}`;

  return {
    fiscal: 'Quarter',
    fiscal_quarter: fiscalQuarter,
    fiscal_year: mostRecentQuarterYear.toString(),
    e_or_a: 'A', // Most recent past quarter should default to Actual
    calendar_date: calendarDate,
  };
};

export const useExtraModeParams = (modeId) => {
  const [modeExtraParams, setModeExtraParams] = React.useState([]);
  const [state, setState] = React.useState({});

  const onChangeModeExtraParams = (param, value) => {
    setState((prevState) => ({
      ...prevState,
      [param]: value,
    }));
  };

  React.useEffect(() => {
    // if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.earnings_grid_template) {
    //   const params = [
    //   'fiscal_year_end_date',
    //   'fiscal_quarter_end_date',
    //   'fiscal_quarter',
    //   'fiscal_quarter_fiscal_year',
    //   'fiscal_quarter_e_or_a',
    //   'year_ago_fiscal_quarter_e_or_a',
    //   'fiscal_year',
    //   'fiscal_year_e_or_a',
    //   'year_ago_fiscal_year_e_or_a',
    //   'convert_to_usd',
    // ];
    // setModeExtraParams(params);
    // setState({
    //   fiscal: 'Quarter',
    //   fiscal_quarter_end_date: getDefaultQuarterEnd(),
    //   fiscal_quarter: '',
    //   fiscal_quarter_fiscal_year: '',
    //   fiscal_quarter_e_or_a: 'E',
    //   year_ago_fiscal_quarter_e_or_a: 'E',
    //   fiscal_year: '',
    //   fiscal_year_e_or_a: 'E',
    //   year_ago_fiscal_year_e_or_a: 'E',
    //   fiscal_year_end_date: '',
    //   convert_to_usd: 'false',
    // });
    // }
    if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.portfolio_monitoring_template) {
      const params = ['fiscal', 'fiscal_quarter', 'fiscal_year', 'e_or_a', 'calendar_date'];
      const defaults = getDefaultPortfolioMonitoringParams();
      setModeExtraParams(params);
      setState(defaults);
    }
    if (modeId === DOCUMENT_TEMPLATE_MODE_IDS.ddq_template) {
      setModeExtraParams(['fund_name']);
      setState({ fund_name: '' });
    }
  }, [modeId]);

  return { modeExtraParams, state, onChangeModeExtraParams };
};
